import Day from "../Day"

export default function Week(props) {
    let enablePast =  props.enablePast;
    let enableFuture = props.enableFuture;
    let disableDay = props.disableDay; 
    return (
        <div className="flex-container flex-horizontal align-center">
            {props.days.map((day, index) => {
                return <Day {...day} onChange={props.onChange} controllers={props.controllers} key={index + "_" + day.newDate.dayInt} enablePast={enablePast} enableFuture={enableFuture} disableDay={disableDay}/>
            })
            }
        </div>
    )
} 